"use strict";

define('model/document.decision.type',['./base'], function (BaseModel) {
  var DocumentDecisionType = BaseModel.extend({}, {
    all: function all(documentId) {
      return this.createCollection('/rs/api/decision/types/:documentId').params({
        documentId: documentId
      });
    }
  });
  return DocumentDecisionType;
});

